import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Modern functional HTTP interceptor for adding authentication token
 * Replaces class-based LoaderInterceptor auth logic
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');

  if (token) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
    return next(authReq);
  }

  return next(req);
};
